import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { decorAPI } from '../../utils/api';

export default function DecorAbout() {
  const [aboutData, setAboutData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    decorAPI.getAbout().then(setAboutData).catch(() => {});
  }, []);

  const paras = (aboutData?.description || 
    "Sabitri Catering & Tent House was born from a passion for transforming ordinary spaces into magnificent wedding venues. Managed by Krishna Khanal (9867155395) and Laxmikant Timilsina (9857074103) from Yogikuti, Butwal.\n\nFrom intimate family mandaps to grand palace receptions, our portfolio spans every style — traditional Palpali floral mandaps, royal Mughal arches, marquee tents, and contemporary lighting.\n\nWe source fresh imported florals, premium velvet draping, and artisanal handicrafts, ensuring every detail speaks of luxury."
  ).split('\n\n');

  return (
    <div className="sec-wrapper">
      {/* Unified Vivah Nepal Hero Banner */}
      <section className="hero-section">
        <div className="hero-content">
          <div style={{ marginBottom: '1.2rem' }}>
            <span className="badge-hero-top">
              ✦ SABITRI MANDAP DECOR & TENT HOUSE ✦
            </span>
          </div>

          <h1 className="hero-title">
            Transforming Spaces into <span className="hero-title-gradient">Unforgettable Memories</span>
          </h1>

          <p className="hero-subtitle">
            Crafting royal wedding mandaps, marquee tents, stage backdrops, and Palpali floral decor. Main office at <strong>Yogikuti Chowk, Butwal-10, Nepal</strong>.
          </p>

          <div className="hero-cta-group">
            <button className="btn btn-secondary" onClick={() => navigate('/decor/catalog')}>
              Explore Decor Catalog →
            </button>
            <button className="btn btn-tertiary" onClick={() => navigate('/decor/quote')}>
              Request Custom Quote →
            </button>
          </div>
        </div>
      </section>

      {/* Stat Boxes */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '1.5rem',
        marginBottom: '3.5rem'
      }}>
        <div className="stat-box">
          <div className="stat-number">{aboutData?.events_done || 500}+</div>
          <div className="stat-label">Royal Mandaps & Events Done</div>
        </div>
        <div className="stat-box">
          <div className="stat-number">{aboutData?.team_size || 40}+</div>
          <div className="stat-label">Artisans & Stage Designers</div>
        </div>
        <div className="stat-box">
          <div className="stat-number">{aboutData?.years_active || 10}+</div>
          <div className="stat-label">Years of Excellence in Nepal</div>
        </div>
        <div className="stat-box">
          <div className="stat-number">Yogikuti</div>
          <div className="stat-label">Butwal Corporate Office</div>
        </div>
      </div>

      {/* About Description Card */}
      <div className="card" style={{ marginBottom: '3.5rem', border: '1.5px solid #D4AF37' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem', alignItems: 'center' }}>
          <div>
            <span className="badge-light">🌸 Premier Mandap & Event Styling</span>
            <h2 style={{ fontFamily: 'var(--serif)', fontSize: '2.2rem', fontWeight: 700, color: '#9E1B32', margin: '0.4rem 0 0.8rem' }}>
              {aboutData?.tagline || "Sabitri Decor & Tent House Services"}
            </h2>
            {paras.map((p, i) => (
              <p key={i} style={{ color: '#6E615E', lineHeight: 1.7, marginBottom: '0.9rem', fontSize: '0.9rem' }}>
                {p}
              </p>
            ))}
            <div style={{ display: 'flex', gap: '0.8rem', marginTop: '1.4rem', flexWrap: 'wrap' }}>
              <a href="tel:9867155395" className="btn btn-primary">
                📞 Call Krishna: 9867155395
              </a>
              <button className="btn btn-secondary" onClick={() => navigate('/decor/booking')}>
                Book Event Decor →
              </button>
            </div>
          </div>

          <div style={{
            background: '#FAF6ED',
            padding: '1.8rem',
            borderRadius: '20px',
            border: '1px solid #E8DFD1'
          }}>
            <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.5rem', color: '#1C1014', marginBottom: '1rem', fontWeight: 700 }}>
              📍 Decor Headquarters
            </h3>
            <div style={{ fontSize: '0.88rem', color: '#6E615E', lineHeight: 1.8 }}>
              🏢 <strong>Main Office:</strong> Yogikuti Chowk, Butwal-10, Nepal<br />
              💐 <strong>Managing Director:</strong> Krishna Khanal (9867155395)<br />
              💍 <strong>Partner Director:</strong> Laxmikant Timilsina (9857074103)<br />
              💻 <strong>Technical Support:</strong> Prakash Sharma Timilsina (pourkas.org)
            </div>
          </div>
        </div>
      </div>

      {/* 3 Pillars Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '1.8rem'
      }}>
        {[
          ['🌸', 'Palpali Floral Mandap', 'Fresh marigolds, red roses, custom brass lamps, and traditional royal arches.'],
          ['✨', 'Fairy Light & Marquee Tents', 'Edison bulbs, ambient LED mood lighting, and weatherproof outdoor marquee tents.'],
          ['🏛️', 'Stage & Backdrop Styling', 'Elevated reception backdrops, royal throne seats, and white floral arches.']
        ].map(([emoji, title, desc]) => (
          <div key={title} className="card" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '0.6rem' }}>{emoji}</div>
            <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.4rem', fontWeight: 700, color: '#9E1B32', marginBottom: '0.4rem' }}>
              {title}
            </h3>
            <p style={{ fontSize: '0.86rem', color: '#6E615E', lineHeight: 1.65 }}>
              {desc}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}